export enum HashCoreAccessGateKind {
  NotFound = "NotFound",
}
